import React from 'react';

import moment from 'moment';

import Layout from '../../containers/Layout';
import Table from '../../components/Table';
import Pagination from '../../components/Pagination';

import formatCurrency from '../../helpers/formatCurrency';
import BillcomSettlementParentService from '../../services/BillcomSettlementParent';
import usePagination from '../../hooks/usePagination';

export default function BillComSettlementsPage() {
  const {
    currentPage,
    switchToPage,
    pageTotal,
    data: billcomSettlementsParents,
  } = usePagination({
    queryKey: ['billcomSettlementsParents'],
    queryFn: BillcomSettlementParentService.getBillComSettlementsParents,
  });

  const cols = [
    {
      title: 'Process Date',
      keys: ['process_date'],
      format: (value) => moment(value).format('M/D/YY'),
      link: (row) => `/billcom-settlements/${row.id}`,
    },
    {
      title: 'Amount',
      keys: ['amount'],
      format: (value) => {
        return `$${formatCurrency(value)}`;
      },
    },
    {
      title: 'Type',
      keys: ['type'],
    },
    {
      title: 'Status',
      keys: ['status'],
    },
  ];

  return (
    <Layout>
      <div className="flex">
        {/* Content area */}
        <div className="relative flex flex-col flex-1 overflow-y-auto overflow-x-hidden">
          <main className="grow">
            <div className="px-4 sm:px-6 lg:px-8 py-8 pb-10 w-full max-w-9xl mx-auto">
              {/* Page header */}
              <div className="sm:flex sm:justify-between sm:items-center mb-8">
                {/* Left: Title */}
                <div className="mb-4 sm:mb-0">
                  <h1 className="text-2xl md:text-3xl text-slate-800 dark:text-slate-100 font-bold">
                    Bill.com Settlements
                  </h1>
                </div>
              </div>

              <div className="p-7 col-span-full sm:col-span-6 xl:col-span-4 bg-white dark:bg-slate-800 shadow-lg rounded-sm border border-slate-200 dark:border-slate-700 mb-10">
                <Table
                  cols={cols}
                  rows={billcomSettlementsParents?.items}
                  title="Bill.com Settlements"
                  minHeight={565}
                />
                <Pagination
                  pageTotal={pageTotal}
                  switchToPage={switchToPage}
                  currentPage={currentPage}
                />
              </div>
            </div>
          </main>
        </div>
      </div>
    </Layout>
  );
}
